export const works = [
  {
    id: "san-sheng-san-shi-shi-li-tao-hua",
    title: "三生三世十里桃花",
    type: "电视剧",
    year: 2017,
    role: "白浅 / 素素 / 司音",
    director: "林玉芬",
    episodes: 58,
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fantasy%20poster%20of%20a%20noble%20woman%20in%20flowing%20pale%20pink%20hanfu%20standing%20amid%20peach%20blossom%20petals%2C%20misty%20mountains%20background%2C%20soft%20warm%20rose%20and%20gold%20palette%2C%20cinematic%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-tao-01&orientation=portrait",
    synopsis: "讲述了青丘帝姬白浅与九重天太子夜华历经三生三世的爱恨纠葛。从司音到素素再到白浅，杨幂塑造了层次分明、悲喜交织的经典仙侠角色，成为当年现象级爆款剧集。",
    cast: ["杨幂", "赵又廷", "张智尧", "迪丽热巴"],
    tags: ["仙侠", "古装", "热门"],
  },
  {
    id: "gong-suo-xin-yu",
    title: "宫锁心玉",
    type: "电视剧",
    year: 2011,
    role: "洛晴川",
    director: "李慧珠",
    episodes: 35,
    cover: "https://readdy.ai/api/search-image?query=Classical%20Chinese%20palace%20drama%20poster%20of%20a%20young%20woman%20in%20ornate%20rose-red%20Qing%20dynasty%20costume%2C%20ancient%20courtyard%20with%20red%20lanterns%2C%20warm%20golden%20light%2C%20refined%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-gong-02&orientation=portrait",
    synopsis: "现代少女洛晴川穿越到清朝康熙年间，卷入皇子夺嫡的宫廷风云。该剧让杨幂一夜爆红，成为清穿剧的代表作品。",
    cast: ["杨幂", "冯绍峰", "何晟铭", "佟丽娅"],
    tags: ["古装", "穿越", "经典"],
  },
  {
    id: "gu-jian-qi-tan",
    title: "古剑奇谭",
    type: "电视剧",
    year: 2014,
    role: "风晴雪",
    director: "黄伟明",
    episodes: 50,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20poster%20of%20a%20gentle%20woman%20in%20soft%20blue%20and%20white%20silk%20robe%20holding%20a%20jade%20flute%2C%20snow%20mountain%20and%20glowing%20sword%20background%2C%20dreamy%20atmosphere%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-gu-03&orientation=portrait",
    synopsis: "改编自同名游戏，讲述百里屠苏与风晴雪等人守护天下苍生的故事。杨幂饰演的风晴雪温柔坚韧，剧集掀起仙侠剧热潮。",
    cast: ["杨幂", "李易峰", "张智尧", "乔振宇"],
    tags: ["仙侠", "古装", "热门"],
  },
  {
    id: "qin-ai-de-fan-yi-guan",
    title: "亲爱的翻译官",
    type: "电视剧",
    year: 2016,
    role: "乔菲",
    director: "王迎",
    episodes: 42,
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20confident%20young%20professional%20woman%20in%20beige%20trench%20coat%20holding%20a%20notebook%2C%20bright%20city%20office%20background%2C%20warm%20natural%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-fanyi-04&orientation=portrait",
    synopsis: "讲述高级翻译乔菲与程家阳在高翻院相遇相知，追求职业理想的故事。杨幂演绎职场女性成长，收视与话题双丰收。",
    cast: ["杨幂", "黄轩", "高伟光", "周奇奇"],
    tags: ["都市", "职场", "热门"],
  },
  {
    id: "fu-yao",
    title: "扶摇",
    type: "电视剧",
    year: 2018,
    role: "孟扶摇",
    director: "杨文军",
    episodes: 66,
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20poster%20of%20a%20heroic%20woman%20in%20deep%20rose%20and%20gold%20armor%20holding%20a%20sword%2C%20dramatic%20sky%20and%20ancient%20palace%20background%2C%20warm%20cinematic%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-fuyao-05&orientation=portrait",
    synopsis: "讲述出身平凡的孟扶摇一路披荆斩棘、匡扶正义的传奇经历。杨幂挑战打戏与大女主成长线，展现飒爽一面。",
    cast: ["杨幂", "阮经天", "高伟光", "刘奕君"],
    tags: ["古装", "武侠", "大女主"],
  },
  {
    id: "hu-zhou-fu-ren",
    title: "斛珠夫人",
    type: "电视剧",
    year: 2021,
    role: "方海市 / 叶海市",
    director: "金沙",
    episodes: 46,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%20of%20a%20young%20woman%20in%20embroidered%20rose%20and%20gold%20traditional%20dress%20with%20elaborate%20hairpin%2C%20lantern-lit%20ancient%20hall%2C%20warm%20moody%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-huzhu-06&orientation=portrait",
    synopsis: "改编自萧如瑟同名小说，讲述方海市在乱世中的命运与情感。杨幂演绎女扮男装的坚韧角色，权谋与情感交织。",
    cast: ["杨幂", "陈伟霆", "徐开骋", "陈小纭"],
    tags: ["古装", "权谋", "古偶"],
  },
  {
    id: "ni-shi-ying-jiu",
    title: "逆时营救",
    type: "电影",
    year: 2017,
    role: "夏天",
    director: "尹鸿承",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Science%20fiction%20thriller%20movie%20poster%20of%20a%20determined%20woman%20scientist%20in%20white%20coat%2C%20futuristic%20laboratory%20with%20blue%20and%20amber%20lights%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-nishi-07&orientation=portrait",
    synopsis: "物理研究员夏天为拯救被绑架的儿子，多次穿越时空逆转命运。杨幂挑战科幻动作题材，塑造果敢的母亲形象。",
    cast: ["杨幂", "霍建华", "金士杰", "刘畅"],
    tags: ["科幻", "动作", "悬疑"],
  },
  {
    id: "xiu-chun-dao-2",
    title: "绣春刀II：修罗战场",
    type: "电影",
    year: 2017,
    role: "北斋",
    director: "路阳",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Historical%20martial%20arts%20film%20poster%20of%20an%20elegant%20woman%20in%20Ming%20dynasty%20painter%20robe%20holding%20a%20scroll%2C%20rainy%20ancient%20town%20background%2C%20moody%20warm%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-xiuchun-08&orientation=portrait",
    synopsis: "明末乱世中，画师北斋与锦衣卫沈炼的命运交织。杨幂演绎温婉又坚韧的文人女子，展现细腻演技。",
    cast: ["杨幂", "张震", "张译", "雷佳音"],
    tags: ["武侠", "古装", "口碑"],
  },
  {
    id: "ci-sha-xiao-shuo-jia",
    title: "刺杀小说家",
    type: "电影",
    year: 2021,
    role: "屠灵",
    director: "路阳",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20action%20movie%20poster%20of%20a%20sleek%20woman%20in%20black%20leather%20coat%2C%20neon-lit%20rainy%20city%20background%2C%20rose%20and%20gold%20accents%2C%20cinematic%20lighting%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-cisha-09&orientation=portrait",
    synopsis: "现实与小说世界相互影响的奇幻故事中，杨幂饰演干练果决的屠灵，动作戏与冷峻气质令人印象深刻。",
    cast: ["杨幂", "雷佳音", "董子健", "于和伟"],
    tags: ["奇幻", "动作", "大制作"],
  },
  {
    id: "bao-bei-er",
    title: "宝贝儿",
    type: "电影",
    year: 2018,
    role: "江萌",
    director: "刘杰",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Realistic%20drama%20film%20poster%20of%20a%20plain%20woman%20in%20simple%20grey%20coat%20walking%20in%20an%20old%20town%20street%2C%20overcast%20soft%20light%2C%20muted%20warm%20tones%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-baobei-10&orientation=portrait",
    synopsis: "杨幂素颜出演清洁工江萌，为一个有缺陷的弃婴奔走。她突破形象、挑战文艺现实题材，收获业内好评。",
    cast: ["杨幂", "郭京飞", "李鸿其"],
    tags: ["文艺", "现实", "突破"],
  },
  {
    id: "wo-shi-zheng-ren",
    title: "我是证人",
    type: "电影",
    year: 2015,
    role: "路小星",
    director: "安相勋",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20of%20a%20blind%20young%20woman%20with%20a%20white%20cane%20in%20a%20dim%20alley%2C%20moody%20amber%20and%20shadow%20lighting%2C%20cinematic%20tension%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-zhengren-11&orientation=portrait",
    synopsis: "失明的前警官路小星成为一桩案件的目击证人，凭听觉与记忆追查真相。杨幂挑战盲人角色，表演细腻。",
    cast: ["杨幂", "鹿晗", "王景春", "朱亚文"],
    tags: ["悬疑", "犯罪", "改编"],
  },
  {
    id: "xiao-shi-dai",
    title: "小时代",
    type: "电影",
    year: 2013,
    role: "林萧",
    director: "郭敬明",
    episodes: 0,
    cover: "https://readdy.ai/api/search-image?query=Glamorous%20urban%20fashion%20film%20poster%20of%20a%20stylish%20young%20woman%20in%20elegant%20dress%2C%20luxurious%20modern%20city%20background%2C%20warm%20rose%20and%20gold%20tones%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-xsd-12&orientation=portrait",
    synopsis: "讲述林萧等四位女生在上海的青春、友情与成长。杨幂饰演的林萧真实可爱，系列电影一度成为话题焦点。",
    cast: ["杨幂", "郭采洁", "郭碧婷", "谢依霖"],
    tags: ["青春", "都市", "话题"],
  },
  {
    id: "ni-shi-da-yi-sheng",
    title: "谢谢你医生",
    type: "电视剧",
    year: 2022,
    role: "肖砚",
    director: "张睿",
    episodes: 40,
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20compassionate%20young%20female%20doctor%20in%20white%20coat%20with%20stethoscope%2C%20bright%20hospital%20corridor%20background%2C%20clean%20warm%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-yisheng-13&orientation=portrait",
    synopsis: "急诊科医生肖砚与白术在生死边缘守护生命。杨幂演绎专业冷静又富有人情味的医生角色。",
    cast: ["杨幂", "白宇", "奚美娟", "乔振宇"],
    tags: ["医疗", "都市", "职业"],
  },
  {
    id: "ai-de-er-ba-ding-lv",
    title: "爱的二八定律",
    type: "电视剧",
    year: 2022,
    role: "秦施",
    director: "林妍",
    episodes: 35,
    cover: "https://readdy.ai/api/search-image?query=Modern%20romance%20drama%20poster%20of%20a%20chic%20young%20businesswoman%20in%20tailored%20suit%20holding%20coffee%2C%20stylish%20office%20background%2C%20warm%20rose%20and%20gold%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-erdeng-14&orientation=portrait",
    synopsis: "精英律师秦施与宅男阳华上演先婚后爱。杨幂诠释独立飒爽的都市女性，轻喜剧风格令人耳目一新。",
    cast: ["杨幂", "许凯", "李泽锋", "王东"],
    tags: ["都市", "爱情", "职场"],
  },
  {
    id: "ha-er-bin-yi-jiu-si-si",
    title: "哈尔滨一九四四",
    type: "电视剧",
    year: 2024,
    role: "关雪",
    director: "张黎",
    episodes: 40,
    cover: "https://readdy.ai/api/search-image?query=Period%20spy%20drama%20poster%20of%20a%20resolute%20woman%20in%201940s%20military%20coat%2C%20snowy%20old%20northeastern%20city%20street%20background%2C%20cold%20blue%20with%20warm%20highlights%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-haerbin-15&orientation=portrait",
    synopsis: "1944年的哈尔滨，杨幂饰演身份复杂的关雪，在谍战风云中步步为营。她挑战年代谍战题材，气场全开。",
    cast: ["杨幂", "秦昊", "张子贤", "王鸥"],
    tags: ["谍战", "年代", "新剧"],
  },
  {
    id: "zhu-meng-qing-yuan",
    title: "筑梦情缘",
    type: "电视剧",
    year: 2019,
    role: "傅函君",
    director: "金沙",
    episodes: 45,
    cover: "https://readdy.ai/api/search-image?query=Retro%20romance%20drama%20poster%20of%20a%20poised%20woman%20in%201930s%20cheongsam%2C%20old%20Shanghai%20architecture%20background%2C%20warm%20golden%20vintage%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-zhumeng-16&orientation=portrait",
    synopsis: "上世纪二三十年代的上海，建筑设计师傅函君追逐理想。杨幂演绎民国女性的坚韧与才情。",
    cast: ["杨幂", "霍建华", "曾江", "姜宏波"],
    tags: ["年代", "民国", "励志"],
  },
  {
    id: "bao-feng-yan",
    title: "暴风眼",
    type: "电视剧",
    year: 2021,
    role: "安静",
    director: "金沙",
    episodes: 42,
    cover: "https://readdy.ai/api/search-image?query=Modern%20espionage%20drama%20poster%20of%20a%20composed%20female%20investigator%20in%20dark%20trench%20coat%2C%20night%20cityscape%20with%20warm%20street%20lights%2C%20cinematic%20lighting%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-baofeng-17&orientation=portrait",
    synopsis: "国安侦查员安静与团队守护国家安全的惊险故事。杨幂挑战正剧题材，塑造睿智冷静的侦查员形象。",
    cast: ["杨幂", "张彬彬", "王骁", "石凉"],
    tags: ["悬疑", "国安", "正剧"],
  },
  {
    id: "tan-pan-guan",
    title: "谈判官",
    type: "电视剧",
    year: 2018,
    role: "童薇",
    director: "刘一志",
    episodes: 42,
    cover: "https://readdy.ai/api/search-image?query=Urban%20professional%20drama%20poster%20of%20an%20elegant%20female%20negotiator%20in%20white%20blazer%2C%20glass%20office%20tower%20background%2C%20warm%20rose%20and%20gold%20light%2C%20editorial%20portrait%2C%20high%20detail&width=600&height=900&seq=ym-work-tanpan-18&orientation=portrait",
    synopsis: "资深谈判专家童薇在职场与情感中成长。杨幂演绎机智干练的谈判高手，展现都市精英风采。",
    cast: ["杨幂", "黄子韬", "郭品超", "毛林林"],
    tags: ["都市", "职场", "爱情"],
  },
];